module.exports = __webpack_public_path__ + "media/images/refund-d94a7524ded4cf3565cf7ea136d31132.svg";